import { OChainId, TChainId } from 'modules/api';
import { Locale } from './locales';

const chainTranslation: Record<TChainId, string> = {
  [OChainId.ethereum]: 'Ethereum',
  [OChainId.holesky]: 'Holesky',
  [OChainId.unsupported]: 'Unsupported network',
  [OChainId.mantle]: 'Mantle',
  [OChainId.okxXLayer]: 'OKX (X-Layer)',
  [OChainId.okxXLayerTestnet]: 'OKX (X-Layer Testnet)',
  [OChainId.manta]: 'Manta',
  [OChainId.scroll]: 'Scroll',
  [OChainId.linea]: 'Linea',
  [OChainId.lineaSepolia]: 'Linea Sepolia',
  [OChainId.mantleSepolia]: 'Mantle Sepolia',
  [OChainId.zircuit]: 'Zircuit',
  [OChainId.binanceSmartChain]: 'BNB',
  [OChainId.binanceSmartChainTestnet]: 'BNB testnet',
  [OChainId.sepolia]: 'Sepolia',
  [OChainId.base]: 'Base',
  [OChainId.baseSepoliaTestnet]: 'Base Sepolia',
  [OChainId.berachainBartioTestnet]: 'Berachain bArtio',
  [OChainId.berachain]: 'Berachain',
  [OChainId.corn]: 'Corn',
  [OChainId.bob]: 'BOB',
  [OChainId.swell]: 'Swellchain',
  [OChainId.sonic]: 'Sonic',
  [OChainId.morph]: 'Morph',
  [OChainId.morphHolesky]: 'Morph Holesky',
};

export const globalTranslation = {
  [Locale.en]: {
    appName: 'LombardFinance',
    format: {
      date: '{value, date, medium}',
      timeShort: '{value, time, short}',
      numberCompact: '{value, number, ::compact-short}',
    },
    unit: {
      usdValue: '${value}',
      pctValue: '{value}%',
      tokenValue: '{value} {token}',
    },
    wallets: {
      confirmTxn: 'Please confirm the transaction in your wallet.',
    },
    requestError: {
      switchNetwork: 'Failed to switch network.',
      getLbtcAllowance: 'Unable to get LBTC allowance',
      unknown: 'Unknown Error',
    },
    chain: chainTranslation,
    validation: {
      required: 'This field is required',
      numberOnly: 'Must be a number',
      min: 'Minimum amount {value}',
      max: 'Maximum amount {value}',
      email: 'Invalid email address',
      address: 'Invalid address',
      lowBalance: 'Your balance is not sufficient',
      notEnoughToken: "You don't have enough {token} in your wallet",
    },
    general: {
      on: 'on',
      or: 'or',
      and: 'and',
      equals: '=',
    },
    withdrawal: 'No funds available for withdrawal',
    fundsLocked: 'Your deposit will be available to withdraw on {time}',
  },
};
